import React, { useCallback, useRef } from "react";
import { Overlay, Popover, Form } from "react-bootstrap";
import Select, { components } from 'react-select';
import { Controller } from 'react-hook-form';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { useCircularTab } from "../../hooks/useCircularTab";
import { NEW_EDIT_WORK, NEW_QA_REVIEW } from "../../../../../routeNames.js";

// Custom dropdown indicator component
const DropdownIndicator = ({ filterState, state, ...props }) => (
  <components.DropdownIndicator {...props}>
    {filterState && filterState[state] && filterState[state].length > 1 ? (
      <TbGridDots style={{ fontSize: "1.5em" }} />
    ) : (
      <HiChevronDown style={{ fontSize: "1.5em" }} />
    )}
  </components.DropdownIndicator>
);

// Reusable switch field component
const SwitchField = ({ label, name, register, disabled, checked }) => (
  <div className='additional-check'>
    <Form.Check
      {...register(name)}
      type="switch"
      inline
      reverse
      disabled={disabled}
      checked={checked}
      label={label}
    />
  </div>
);

const AdditionalInfoPopover = ({ 
  isViewOnllyGrid,
  additionalInfoState,
  formEobValues,
  jobData,
}) => {
  
  // Use the custom hook
  const {
    register,
    handleSubmit,
    setValue,
    control,
    errors,
    reasonData,
    documentData,
    filterState,
    values,
    onSubmit,
    handleModalClose,
    handleStatusChange,
    // Additional Info State
    isAdditionalInfoOptions,
    aditionalInfoRef,
    additionalModal,
    job_log,
    
  } = additionalInfoState


  const pathname = window.location.pathname;
  const isQaScreen = pathname === NEW_QA_REVIEW
  const isViewScreen = (pathname == NEW_EDIT_WORK + job_log)

  const renderClass = (name, defaultClass, key) => {
    // Normalize values - treat undefined, null, and empty string as equivalent
    const normalizeValue = (val) => (val === undefined || val === null || val === '') ? null : val;

    // Check if two arrays have the same values (order doesn't matter)
    const arraysEqual = (arr1, arr2) => {
      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
      if (arr1.length !== arr2.length) return false;

      // Sort and compare
      const sorted1 = [...arr1].sort();
      const sorted2 = [...arr2].sort();

      return sorted1.every((val, index) => val === sorted2[index]);
    };

    let currentValue = normalizeValue(values?.[key]);
    let originalValue = normalizeValue(jobData?.grid_data?.[name]);

    let isDirectTrue;

    // Check if both are arrays
    if (Array.isArray(currentValue) && Array.isArray(originalValue)) {
      isDirectTrue = !arraysEqual(currentValue, originalValue);
    }
    // Check if one is array and other is not
    else if (Array.isArray(currentValue) || Array.isArray(originalValue)) {
      isDirectTrue = true;
    }
    // Regular comparison for non-array values
    else {
      isDirectTrue = currentValue !== originalValue;
    }

    let edited_data_name = formEobValues?.edited_data?.[name];
    let isQaError = edited_data_name?.error;

    if ((isViewScreen || isQaScreen) && ((isQaScreen && isDirectTrue) || (isViewScreen && isQaError))) {
      return defaultClass + ' qa-field';
    }

    return defaultClass;
  };



 const cercularRrf = useRef(null);
  useCircularTab(cercularRrf ,additionalModal);
  return (
    <Overlay
      onHide={handleModalClose}
      show={additionalModal}
      target={aditionalInfoRef.current}
      containerPadding={80} 
      placement="top"
    >
      {(props) => (
        <Popover className='pc-popover-popup' id="pc-popover-popup" {...props}>
          <Popover.Header className='p-1' style={{ fontSize: '1em', backgroundColor: "#6ba2b6" }}>
            <div className='d-flex justify-content-between align-items-center'>
              <span className='text-white fw-bold'>Additional Information</span>
              <button 
                className='btn text-white fw-bold' 
                onClick={handleModalClose}
              >
                &times;
              </button>
            </div>
          </Popover.Header>
          
          <Popover.Body>
            <Form onSubmit={handleSubmit(onSubmit)} ref={cercularRrf}>
              <div className='row align-items-center' >
                
                {/* Status Field */}
                {isAdditionalInfoOptions?.status && (
                  <div className="mb-10 col-lg-4">
                    <Form.Select 
                      {...register("status")}
                      className={renderClass('qdx_status','form-control form-control-solid b-r-10 input-focus-shadow' ,"status")}
                      value={values.status}
                      disabled={isViewOnllyGrid}
                      isInvalid={!!errors.status}
                      onChange={(e) => handleStatusChange(e.target.value)}
                    >
                      <option value="">Status</option>
                      <option value="COMPLETE">Complete</option>
                      <option value="INCOMPLETE">Incomplete</option>
                    </Form.Select>
                    {errors.status && (
                      <span className="text-danger">{errors.status.message}</span>
                    )}
                  </div>
                )}

                {/* Reason Field */}
                {isAdditionalInfoOptions?.reason && (
                  <div className="mb-10 col-lg-4">
                    <Controller
                      name="reason"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isMulti
                          value={reasonData.filter((option) => 
                            field?.value?.includes(option.value)
                          )}
                          isDisabled={isViewOnllyGrid}
                          onChange={(selectedOptions) =>
                            field.onChange(selectedOptions.map((opt) => opt.value))
                          }
                          options={reasonData}
                          
                          components={{ 
                            DropdownIndicator: (props) => (
                              <DropdownIndicator 
                                {...props} 
                                state="reason" 
                                filterState={filterState} 
                              />
                            )
                          }}
                          className="select-search input-focus-shadow"
                          placeholder="Reasons"
                          styles={{
                             control: (styles, state) => ({
                              ...styles,
                              backgroundColor:`${ renderClass("qdx_reason",'','reason') && '#ecf38f'}` ,
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: state.isFocused ? "auto" : "30px",
                            }),

                          }}
                        />
                      )}
                    />
                    {errors.reason && (
                      <span className="text-danger">{errors.reason.message}</span>
                    )}
                  </div>
                )}

                {/* Document Classification Field */}
                {isAdditionalInfoOptions?.document_classification && (
                  <div className="mb-10 col-lg-4">
                    <Form.Select 
                      {...register("document_classification")}
                      disabled={isViewOnllyGrid}
                      className={renderClass('qdx_classification', 'form-control form-control-solid b-r-10 input-focus-shadow', 'document_classification')}
                      value={values.document_classification}
                      onChange={(e) => setValue("document_classification", e.target.value)}
                    >
                      <option value=''>Document Classification</option>
                      {documentData.map((option, index) => (
                        <option key={index} value={option?.value}>
                          {option?.label}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                )}
              </div>

              {/* Switch Fields */}
              {isAdditionalInfoOptions?.extra_info && (
                <div className="d-grid-additional-info mt-3 mb-2">
                  <div className={renderClass('is_orphaned_check', '', 'is_orphaned_check')}>
                    <SwitchField 
                      label="Orphaned Check" 
                      name="is_orphaned_check" 
                      register={register} 
                      disabled={isViewOnllyGrid} 
                      checked={values.is_orphaned_check} 
                    />
                  </div>
                  <div className={renderClass('is_missing_check_image', '', 'is_missing_check_image')}>
                    <SwitchField 
                      label="Missing Check Image" 
                      name="is_missing_check_image" 
                      register={register} 
                      disabled={isViewOnllyGrid} 
                      checked={values.is_missing_check_image} 
                    />
                  </div>
                  <div className={renderClass('is_forced_balancing', '', 'is_forced_balancing')}>
                    <SwitchField 
                      label="Forced Balancing" 
                      name="is_forced_balancing" 
                      register={register} 
                      disabled={isViewOnllyGrid} 
                      checked={values.is_forced_balancing} 
                    />
                  </div>
                  <div className={renderClass('is_payer_black_listing', '', 'is_payer_black_listing')}>
                    <SwitchField 
                      label="Payer Black Listing" 
                      name="is_payer_black_listing" 
                      register={register} 
                      disabled={isViewOnllyGrid} 
                      checked={values.is_payer_black_listing} 
                    />
                  </div>
                  <div className={renderClass('is_payer_excluding_indexing', '', 'is_payer_excluding_indexing')}>
                    <SwitchField 
                      label="Payer Excluded Indexing" 
                      name="is_payer_excluding_indexing" 
                      register={register} 
                      disabled={isViewOnllyGrid} 
                      checked={values.is_payer_excluding_indexing} 
                    />
                  </div>
                </div>
              )}

              {/* Submit Button */}
              <div className='d-flex flex-row'>
                <div className='col-lg-12 pt-2 text-end'>
                  <button 
                    type='submit' 
                    className='btn btn-light btn-active-primary new-window btn-focus-shadow'
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Form>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  );
};

export default AdditionalInfoPopover;